/**
 * Returns "rtl" when the value is empty or starts with Arabic,
 * "ltr" when the first letter/digit is Latin or a digit.
 *
 * Usage:  <input dir={autoDir(value)} value={value} … />
 */
export function autoDir(
  v: string | number | null | undefined,
): "ltr" | "rtl" {
  if (v == null || v === "") return "rtl";
  const s = String(v);
  const m = s.match(/[A-Za-z0-9\u0600-\u06FF]/);
  if (!m) return "rtl";
  return /[A-Za-z0-9]/.test(m[0]) ? "ltr" : "rtl";
}
